import type { AuthedAxiosRequests } from 'features/auth'
import { isMissingAccessError } from 'features/permissions/utils/isMissingAccessError'
import {
  type RolodexV3UserScope,
  rolodexV3UserScopesResponseSchema,
} from 'features/permissions/utils/policyScopeEvaluation'

/** GET /users/{id}/scopes — same endpoint Manage Access already hydrates. */
export async function fetchRolodexV3UserScopes(
  axiosClient: AuthedAxiosRequests,
  rolodexUrl: string,
  userId: string
): Promise<RolodexV3UserScope[]> {
  try {
    const response = await axiosClient.get(
      `${rolodexUrl}/api/v3/users/${encodeURIComponent(userId)}/scopes`
    )
    const parsed = rolodexV3UserScopesResponseSchema.safeParse(response.data)
    if (!parsed.success) {
      throw new Error(
        `Failed to parse Rolodex v3 user scopes: ${parsed.error.message}`
      )
    }
    return parsed.data
  } catch (error) {
    if (isMissingAccessError(error)) return []
    throw error
  }
}
